import { withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "onClick", "textContent"]
const _hoisted_2 = ["textContent"]


export default {
  __name: 'RowLink',
  props: {
  to: { type: String, default: null },
  text: { type: String, required: true }
},
  setup(__props) {



return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (__props.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.to,
        custom: ""
      }, {
        default: _withCtx(({ href, navigate }) => [
          _createElementVNode("a", {
            href: href,
            class: "text-gray-900 hover:underline",
            onClick: _withModifiers(navigate, ["stop"]),
            textContent: _toDisplayString(__props.text)
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        textContent: _toDisplayString(__props.text)
      }, null, 8, _hoisted_2))
}
}

}